module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('touch', {
    staticClass: "picker-item",
    on: {
      "panstart": _vm.onPanStart,
      "panmove": _vm.onPanMove,
      "panend": _vm.onPanEnd
    }
  }, [_c('div', {
    directives: [{
      name: "for-nested",
      rawName: "v-for-nested",
      value: ([_vm.currentValues, _vm.keyName]),
      expression: "[currentValues, keyName]"
    }],
    ref: "pickerItemContent",
    staticClass: "picker-item-content",
    style: ({
      transform: 'rotateX(' + _vm.scrollValue + 'deg)'
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c598f08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/picker-item.vue
// module id = 352
// module chunks = 1